import { PersonensucheParty } from '@ps20/bff-models';
import { printPerson } from '@ps20-frontend/utils';

const VN_SUFFIX = ' (Versicherungsnehmer)';
export const getBezeichnungForPerson = (
  person: Pick<PersonensucheParty, 'vorname' | 'nachname' | 'geburtsdatum'>,
  includeVnSuffix?: boolean,
): string => {
  const vnSuffix = includeVnSuffix ? VN_SUFFIX : '';
  return printPerson(person.vorname, person.nachname, person.geburtsdatum, vnSuffix);
};
